import { render, staticRenderFns } from "./Credibility.vue?vue&type=template&id=4cd6d56b&scoped=true"
import script from "./Credibility.vue?vue&type=script&lang=js"
export * from "./Credibility.vue?vue&type=script&lang=js"
import style0 from "./Credibility.vue?vue&type=style&index=0&id=4cd6d56b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cd6d56b",
  null
  
)

export default component.exports